export default __webpack_public_path__ + "static/media/BioinfoFigure1.99328aea.svg";